import {Component, OnInit} from '@angular/core';
import {CaseManagerService} from 'src/app/services/case-manager.service';
import {Chart} from 'angular-highcharts';
import {MlroViewService} from "../../services/mlro-view.service";
import {MlroViewHttpService} from "../../services/mlro-view-http.service";
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-mlro',
  templateUrl: './mlro.component.html',
  styleUrls: ['./mlro.component.scss']
})

export class MlroComponent implements OnInit {
  kibanaUrl = environment.kibanaUrl + "app/dashboards#/view/3ed15b60-1397-11ec-931e-1dc0d58a3400?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))&hide-filter-bar=true";
  statisticsInterval = [
    {viewValue: 'weekly', value: 'weekly'}, // value is the internal id, viewValue is what is shown
    {viewValue: 'monthly', value: 'monthly'},
    {viewValue: 'quarterly', value: 'quarterly'},
    {viewValue: 'yearly', value: 'yearly'}
  ];


  selectedBarChartInterval = 'monthly';

  chartOverdue: Chart;
  chartOpen: Chart;
  chartReported: Chart;
  chartSolved: Chart;


  constructor(private caseManagerService: CaseManagerService,
    private mlroViewService: MlroViewService,
    private mlroViewHttpService: MlroViewHttpService
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.getCharts()
  }

  getChartReport(){
    this.chartReported = this.mlroViewService.getChartReport();
  }

  getTransactionBreak() {
    this.mlroViewHttpService.getCustomerStatus(this.selectedBarChartInterval).subscribe((res: any) => {
      this.chartSolved = this.mlroViewService.getTransactionBreak(res);
    })
  }


  getTrxMonth() {
    this.mlroViewHttpService.getCustomerCases(this.selectedBarChartInterval).subscribe((res: any) => {
      this.chartOpen = this.mlroViewService.getTrxMonth(res);
    })
  }


  getRiskBreakDown() {
    this.mlroViewHttpService.getCustomerRisk(this.selectedBarChartInterval).subscribe((res: any) => {
      this.chartOverdue = this.mlroViewService.getRiskBreakDown(res);
    })
  }

  getCharts() {
    this.getTransactionBreak();
    this.getTrxMonth();
    this.getRiskBreakDown();
    this.getChartReport();
  }

  selectPeriod(frequency: string) {
    this.selectedBarChartInterval = frequency;
    this.getCharts();
  }
}
